import { createApi } from "@reduxjs/toolkit/query/react";
import { mapRowDataToPayload
  ,mapApiToRowData
 } from "@/redux/mappers/Export/CreateNewJob/Product/ProductCessMapper/ProductCess";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const productCessApi = createApi({
  reducerPath: "productCessApi",
  baseQuery,
  tagTypes: ["CessExpDuty"],

  endpoints: (builder) => ({
    getProductCessById: builder.query({
      query: ({ id }) => `/export/product/cessExpDuty/${id}`,
      transformResponse: (response) => {
        console.group("🧾 [getProductCessById]");
        const mapped = mapApiToRowData(response?.data) ?? [];
        console.groupEnd();
        return mapped;
      },
      providesTags: (result, error, id) => [{ type: "CessExpDuty", id }],
    }),
    
    updateCess: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/export/product/cessExpDuty/${id}`,
        method: "PUT",
        body: mapRowDataToPayload(data),
        headers: {
          "X-Request-Id": crypto.randomUUID(),
        },
      }),
      invalidatesTags: ["CessExpDuty"],
    }),
    
  }),
});

export const {
  useUpdateCessMutation,
  useLazyGetProductCessByIdQuery,
} = productCessApi;
